import { type JSX } from 'solid-js';
import './PedalsPanel.css';

export interface PedalsPanelProps {
  onSustainDown: () => void;
  onSustainUp: () => void;
  onVibratoDown: () => void;
  onVibratoUp: () => void;
}

function HoldButton(props: {
  id: string;
  label: string;
  onDown: () => void;
  onUp: () => void;
}): JSX.Element {
  const down = (e: PointerEvent): void => {
    e.preventDefault();
    (e.currentTarget as HTMLElement).setPointerCapture(e.pointerId);
    props.onDown();
  };
  const up = (e: PointerEvent): void => {
    (e.currentTarget as HTMLElement).releasePointerCapture(e.pointerId);
    props.onUp();
  };
  return (
    <button
      class="pedal-btn"
      id={props.id}
      on:pointerdown={down}
      on:pointerup={up}
      on:pointercancel={() => { props.onUp(); }}
    >
      {props.label}
    </button>
  );
}

export function PedalsPanel(props: PedalsPanelProps): JSX.Element {
  return (
    <>
      <HoldButton id="sustain-indicator" label="SUSTAIN" onDown={() => { props.onSustainDown(); }} onUp={() => { props.onSustainUp(); }} />
      <HoldButton id="vibrato-indicator" label="VIBRATO" onDown={() => { props.onVibratoDown(); }} onUp={() => { props.onVibratoUp(); }} />
    </>
  );
}
